import { useLocation } from '@/contexts/LocationContext';
import { Globe, ChevronDown, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const CountrySelector = ({ variant = 'navbar' }) => {
  const { selectedCountry, setSelectedCountry, countries } = useLocation();
  
  const currentCountry = countries.find(c => c.code === selectedCountry) || 
    { code: 'GLOBAL', name: 'Global', flag: '🌍' };

  if (variant === 'navbar') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button 
            className="flex items-center gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-charcoal/50 border border-slate-800 hover:border-gold-500/50 rounded-sm transition-colors text-xs sm:text-sm"
            data-testid="country-selector"
          >
            <span className="text-base sm:text-lg">{currentCountry.flag}</span>
            <span className="hidden sm:inline text-slate-300">{currentCountry.name}</span>
            <ChevronDown className="w-3 h-3 sm:w-4 sm:h-4 text-slate-500" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="end" 
          className="bg-charcoal border-slate-800 w-48"
        >
          {countries.map((country) => (
            <DropdownMenuItem
              key={country.code}
              onClick={() => setSelectedCountry(country.code)}
              className={`flex items-center justify-between cursor-pointer ${
                selectedCountry === country.code ? 'text-gold-500' : 'text-slate-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">{country.flag}</span>
                <span>{country.name}</span>
              </div>
              {selectedCountry === country.code && (
                <Check className="w-4 h-4 text-gold-500" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  // Filter variant for experts page
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button 
          className="flex items-center gap-2 px-4 py-3 bg-charcoal border border-slate-800 hover:border-gold-500/50 rounded-sm transition-colors w-full lg:w-[200px] justify-between"
          data-testid="country-filter"
        >
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-slate-500" />
            <span className="text-sm">{currentCountry.name}</span>
          </div>
          <ChevronDown className="w-4 h-4 text-slate-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="start" 
        className="bg-charcoal border-slate-800 w-[200px]"
      >
        {countries.map((country) => (
          <DropdownMenuItem
            key={country.code}
            onClick={() => setSelectedCountry(country.code)}
            className={`flex items-center justify-between cursor-pointer ${
              selectedCountry === country.code ? 'text-gold-500' : 'text-slate-300'
            }`}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">{country.flag}</span>
              <span className="text-sm">{country.name}</span>
            </div>
            {selectedCountry === country.code && (
              <Check className="w-4 h-4 text-gold-500" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CountrySelector;
